import React, {CSSProperties, FC, ReactElement} from 'react';
interface FilterWrapperProps {
  className?: string,
  style?: CSSProperties;
  children?: ReactElement;
}
const FilterWrapper:FC<FilterWrapperProps> = ({ className, style, children }) => (
  <div
    className={className}
    style={style}
  >
    {children}
  </div>
);

export default FilterWrapper;
